import axios from "axios";

// Chart of Accounts
export const getAccounts = async (params) => {
  const { data } = await axios.get("/api/accounts", { params });
  return data;
};

export const getAccountTree = async () => {
  const { data } = await axios.get("/api/accounts/tree");
  return data;
};

export const getAccount = async (id) => {
  const { data } = await axios.get(`/api/accounts/${id}`);
  return data;
};

export const createAccount = async (accountData) => {
  const { data } = await axios.post("/api/accounts", accountData);
  return data;
};

export const updateAccount = async (id, accountData) => {
  const { data } = await axios.put(`/api/accounts/${id}`, accountData);
  return data;
};

export const deleteAccount = async (id) => {
  const { data } = await axios.delete(`/api/accounts/${id}`);
  return data;
};

// Fiscal Years
export const getFiscalYears = async () => {
  const { data } = await axios.get("/api/fiscal-years");
  return data;
};

export const getFiscalYear = async (id) => {
  const { data } = await axios.get(`/api/fiscal-years/${id}`);
  return data;
};

export const createFiscalYear = async (fyData) => {
  const { data } = await axios.post("/api/fiscal-years", fyData);
  return data;
};

export const closeFiscalYear = async (id) => {
  const { data } = await axios.put(`/api/fiscal-years/${id}/close`);
  return data;
};

export const getPeriods = async (fiscalYearId) => {
  const { data } = await axios.get(`/api/fiscal-years/${fiscalYearId}/periods`);
  return data;
};

export const updatePeriod = async (periodId, periodData) => {
  const { data } = await axios.put(`/api/fiscal-years/periods/${periodId}`, periodData);
  return data;
};

// Journal Entries
export const getJournalEntries = async (params) => {
  const { data } = await axios.get("/api/journal-entries", { params });
  return data;
};

export const getJournalEntry = async (id) => {
  const { data } = await axios.get(`/api/journal-entries/${id}`);
  return data;
};

export const createJournalEntry = async (entryData) => {
  const { data } = await axios.post("/api/journal-entries", entryData);
  return data;
};

export const updateJournalEntry = async (id, entryData) => {
  const { data } = await axios.put(`/api/journal-entries/${id}`, entryData);
  return data;
};

export const postJournalEntry = async (id) => {
  const { data } = await axios.post(`/api/journal-entries/${id}/post`);
  return data;
};

export const voidJournalEntry = async (id, reason) => {
  const { data } = await axios.post(`/api/journal-entries/${id}/void`, { void_reason: reason });
  return data;
};

export const deleteJournalEntry = async (id) => {
  const { data } = await axios.delete(`/api/journal-entries/${id}`);
  return data;
};

// Cash Book
export const getCashBookSetup = async () => {
  const { data } = await axios.get("/api/cash-book/setup");
  return data;
};

export const getCashBookBalances = async () => {
  const { data } = await axios.get("/api/cash-book/balances");
  return data;
};

export const getCashVouchers = async (params) => {
  const { data } = await axios.get("/api/cash-book", { params });
  return data;
};

export const createCashVoucher = async (voucherData) => {
  const { data } = await axios.post("/api/cash-book", voucherData);
  return data;
};

// Reports
export const getTrialBalance = async (params) => {
  const { data } = await axios.get("/api/accounting/reports/trial-balance", { params });
  return data;
};

export const getGeneralLedger = async (params) => {
  const { data } = await axios.get("/api/accounting/reports/general-ledger", { params });
  return data;
};
